import { PROVIDERS } from '@exodus/fiat-client'
import { createSelector } from 'reselect'

const selectorFactory = (configDataSelector, isZeroFeesEnabledForAssetSelector) =>
  createSelector(
    configDataSelector,
    isZeroFeesEnabledForAssetSelector,
    (configData, isZeroFeesEnabledForAsset) => (assetName) => ({
      [PROVIDERS.ramp]:
        configData.zeroFeesEnabled && (!assetName || isZeroFeesEnabledForAsset(assetName)),
      [PROVIDERS.moonpay]:
        configData.moonpayZeroFeesEnabled && (!assetName || isZeroFeesEnabledForAsset(assetName)),
    })
  )

const getHasZeroFeesSelectorDefinition = {
  id: 'getHasZeroFees',
  selectorFactory,
  dependencies: [{ selector: 'configData' }, { selector: 'isZeroFeesEnabledForAsset' }],
}

export default getHasZeroFeesSelectorDefinition
